// extracted by mini-css-extract-plugin
module.exports = {"callRejectIcon":"clinical-portal-3__CallActiveModal__callRejectIcon"};